// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-markdown-body {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    margin: 0;
    background-color: transparent;
    line-height: 1.5;
    word-wrap: break-word;
}

.react-markdown-body [hidden] {
    display: none !important;
}

.react-markdown-body em {
    font-style: italic;
}

.react-markdown-body strong {
    font-weight: bold;
}

.react-markdown-body ul,
.react-markdown-body ol {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 1em;
    list-style-position: inside;
}

.react-markdown-body ul {
    list-style-type: circle;
}

.react-markdown-body ol ul,
.react-markdown-body ul ul {
    list-style-type: disc;
}

.react-markdown-body ol ul ul,
.react-markdown-body ul ul ul,
.react-markdown-body ul ol ul,
.react-markdown-body ol ul ul {
    list-style-type: square;
}

.react-markdown-body ol {
    list-style-type: decimal;
}

.react-markdown-body ol ol,
.react-markdown-body ul ol {
    list-style-type: lower-alpha;
}

.react-markdown-body ol ul ol,
.react-markdown-body ul ul ol,
.react-markdown-body ul ol ol,
.react-markdown-body ol ul ol {
    list-style-type: upper-alpha;
}

.react-markdown-body::before {
    display: table;
    content: "";
}

.react-markdown-body::after {
    display: table;
    clear: both;
    content: "";
}

.react-markdown-body *:first-child {
    margin-top: 0 !important;
}

.react-markdown-body *:last-child {
    margin-bottom: 0 !important;
}

.react-markdown-body p,
.react-markdown-body blockquote,
.react-markdown-body ul,
.react-markdown-body ol,
.react-markdown-body dl,
.react-markdown-body table,
.react-markdown-body pre,
.react-markdown-body details {
    margin-top: 0;
    margin-bottom: 16px;
}

.react-markdown-body li {
    margin-top: .25em;
}
`, "",{"version":3,"sources":["webpack://./client/lib/components/markdown.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,SAAS;IACT,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;;;IAII,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;;;;;IAQI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".react-markdown-body {\n    -ms-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%;\n    margin: 0;\n    background-color: transparent;\n    line-height: 1.5;\n    word-wrap: break-word;\n}\n\n.react-markdown-body [hidden] {\n    display: none !important;\n}\n\n.react-markdown-body em {\n    font-style: italic;\n}\n\n.react-markdown-body strong {\n    font-weight: bold;\n}\n\n.react-markdown-body ul,\n.react-markdown-body ol {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 1em;\n    list-style-position: inside;\n}\n\n.react-markdown-body ul {\n    list-style-type: circle;\n}\n\n.react-markdown-body ol ul,\n.react-markdown-body ul ul {\n    list-style-type: disc;\n}\n\n.react-markdown-body ol ul ul,\n.react-markdown-body ul ul ul,\n.react-markdown-body ul ol ul,\n.react-markdown-body ol ul ul {\n    list-style-type: square;\n}\n\n.react-markdown-body ol {\n    list-style-type: decimal;\n}\n\n.react-markdown-body ol ol,\n.react-markdown-body ul ol {\n    list-style-type: lower-alpha;\n}\n\n.react-markdown-body ol ul ol,\n.react-markdown-body ul ul ol,\n.react-markdown-body ul ol ol,\n.react-markdown-body ol ul ol {\n    list-style-type: upper-alpha;\n}\n\n.react-markdown-body::before {\n    display: table;\n    content: \"\";\n}\n\n.react-markdown-body::after {\n    display: table;\n    clear: both;\n    content: \"\";\n}\n\n.react-markdown-body *:first-child {\n    margin-top: 0 !important;\n}\n\n.react-markdown-body *:last-child {\n    margin-bottom: 0 !important;\n}\n\n.react-markdown-body p,\n.react-markdown-body blockquote,\n.react-markdown-body ul,\n.react-markdown-body ol,\n.react-markdown-body dl,\n.react-markdown-body table,\n.react-markdown-body pre,\n.react-markdown-body details {\n    margin-top: 0;\n    margin-bottom: 16px;\n}\n\n.react-markdown-body li {\n    margin-top: .25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
